class CollectionLayout {
  constructor() {
    this.layout = document.getElementById('CollectionLayout');
    this.toggle = document.querySelector('[data-collection-filter-toggle]');
    this.label = document.querySelector('[data-filter-toggle-label]');

    if (!this.layout || !this.toggle) return;

    this.hideLabel = '隱藏篩選條件';
    this.showLabel = '顯示篩選條件';

    this.toggle.addEventListener('click', this.onToggle.bind(this));
  }

  onToggle() {
    const hidden = this.layout.classList.toggle('collection-layout--filters-hidden');
    this.toggle.setAttribute('aria-expanded', hidden ? 'false' : 'true');
    if (this.label) {
      this.label.textContent = hidden ? this.showLabel : this.hideLabel;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionLayout();
});
